import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import { Constants } from "../constants";
import productList from "../../assets/icons/productList.svg";

export default class ProductListUI extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add( "productList", locale => {

            const buttonView = new ButtonView( locale );

            buttonView.set( {
                label: editor.config.get("productList.toolbarLabel" ) || Constants.productList.fallbackToolbarLabel,
                withText: !editor.config.get("isIconEnabled" ),
                tooltip: !!editor.config.get("isIconEnabled" ),
                icon: editor.config.get("isIconEnabled" ) ? productList : undefined,
            } );

            this.listenTo( buttonView, "execute", () => editor.execute( "productList" ) );

            return buttonView;
        } );
    }
}